import React from "react";
import { PieChart, Pie, Cell, Legend } from "recharts";

export const pieColors: Record<string, string> = {
  LIGHT: "#4fc3f7",
  DARK: "#a0a0a0",
  FLAT: "#ffeb3b",
  BIAS: "#ff8a65",
};

const DEFAULT_COLOR = "#8884d8";

interface PieLabelProps {
  cx: number;
  cy: number;
  midAngle: number;
  outerRadius: number;
  name: string;
  value: number;
}

export function renderPieLabel({
  cx,
  cy,
  midAngle,
  outerRadius,
  name,
  value,
}: PieLabelProps) {
  const RADIAN = Math.PI / 180;
  const radius = outerRadius + 18;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  if (value === 0) return null;
  return (
    <text
      x={x}
      y={y}
      fill={pieColors[name] || "#fff"}
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      fontWeight={700}
      fontSize={14}
      stroke="#181818"
      strokeWidth={0.5}
    >
      {`${name}s: ${value}`}
    </text>
  );
}

interface PieChartComponentProps {
  data: Array<{ name: string; value: number }>;
}

export const PieChartComponent: React.FC<PieChartComponentProps> = ({
  data,
}) => {
  return (
    <PieChart width={400} height={400}>
      <Pie
        data={data}
        cx={200}
        cy={200}
        labelLine={false}
        label={renderPieLabel}
        outerRadius={150}
        fill={DEFAULT_COLOR}
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={pieColors[entry.name] || DEFAULT_COLOR}
          />
        ))}
      </Pie>
      <Legend />
    </PieChart>
  );
};
